import { useEffect } from "react";
import { useNow, greeting, formatLongDate, formatTime, getSeason, pickSeasonLine, rememberSeasonLine } from "@/lib/time";
import { useSite } from "@/context/SiteContext";

export function DateLine() {
  const now = useNow(60000);
  return (
    <span className="font-mono-k text-[11px] tracking-wide text-[#5a665e]" data-testid="site-date">
      {formatLongDate(now)}
    </span>
  );
}

export function HomeGreeting() {
  const now = useNow(15000);
  const { geo } = useSite();
  const seasonName = geo ? getSeason(now, geo.lat) : null;
  const line = seasonName ? pickSeasonLine(seasonName) : null;
  useEffect(() => {
    if (seasonName) rememberSeasonLine(seasonName);
  }, [seasonName]);
  return (
    <div className="rise mb-8" data-testid="home-greeting">
      <p className="font-display italic text-xl sm:text-2xl text-[#1f402b] leading-snug" data-testid="home-greeting-text">
        Hey there, Kia ora, <span className="text-[#c5903b]" data-testid="home-greeting-salutation">{greeting(now)}</span>, welcome to your gateway to better living, naturally!
      </p>
      <p className={`mt-2 text-sm text-[#3d644e] min-h-[1.25rem] transition-opacity duration-500 ${line ? "opacity-100" : "opacity-0"}`} data-testid="home-season-line" data-season={seasonName || ""}>
        {line && (
          <>
            <span className="font-mono-k text-[10px] uppercase tracking-widest text-[#c5903b] mr-2">{seasonName}</span>
            {line}
          </>
        )}
      </p>
      <p className="mt-3 font-mono-k text-[12px] tracking-wide text-[#5a665e]" data-testid="home-date-time">
        <span data-testid="home-date">{formatLongDate(now)}</span>
        <span className="mx-2 text-[#c5903b]">·</span>
        <span className="whitespace-nowrap" data-testid="home-time">{formatTime(now)}</span>
      </p>
    </div>
  );
}
